import { AppDispatch } from 'redux/store'
import { SET_AOL_NAME } from './types'

export function setAOL (name: string | null) {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: SET_AOL_NAME,
      name
    })
  }
}
